import type { SVGProps } from "react";

export const CancelIcon = (props: SVGProps<SVGSVGElement>) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className="fill-current"
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M12.0002 3.2002C16.8603 3.2002 20.8002 7.14009 20.8002 12.0002C20.8002 16.8603 16.8603 20.8002 12.0002 20.8002C7.14009 20.8002 3.2002 16.8603 3.2002 12.0002C3.2002 7.14009 7.14009 3.2002 12.0002 3.2002ZM7.50645 17.6244C8.73824 18.6099 10.3 19.2002 12.0002 19.2002C15.9766 19.2002 19.2002 15.9766 19.2002 12.0002C19.2002 10.3 18.6099 8.73824 17.6244 7.50645L7.50645 17.6244ZM12.0002 4.8002C8.02375 4.8002 4.8002 8.02375 4.8002 12.0002C4.8002 13.7 5.39012 15.2615 6.3752 16.4932L16.4932 6.3752C15.2615 5.39012 13.7 4.8002 12.0002 4.8002Z"
      fill="currentColor"
    />
  </svg>
);
